<template>
  <v-container fluid grid-list-xl class="mt-0 pt-0">
    <v-layout wrap>
      <v-flex xs12 xl8 lg10 offset-xl2 offset-lg1>
        <v-card class="ma-2">
          <v-card-title class="ma-0 pt-0 pb-0 primary--text">
            <h3 class="ma-3">{{ $t('nav.admin.contacts') }}</h3>
          </v-card-title>
          <v-container fluid grid-list-xl class="mt-0 pt-0">
            <v-layout row class="mt-2">
              <v-select v-model="filterDevice" :items="devices" :label="$t('admin.contact.filterDevice')" :clearable="true" class="ma-2"></v-select>
              <v-text-field v-model="filterName" :label="$t('admin.contact.filterName')" class="ma-2"></v-text-field>
              <v-text-field v-model="filterEmail" :label="$t('admin.contact.filterEmail')" class="ma-2"></v-text-field>
              <v-text-field v-model="filterPhoneNumber" :label="$t('admin.contact.filterPhoneNumber')" class="ma-2"></v-text-field>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <autotable
                  :columns="columns"
                  :rows="getFilteredContacts"
                  @newrow="createContact(...arguments)"
                  @change="updateContact"
                  :delete="contactdelete"
                  @delete="deleteContact"
                  dialogtitle="admin.contact.createDialog"
                  keyfield="id"
                ></autotable>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from "vue";
import Autotable from "../common/autotable/Autotable.vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import store from "@/store/";
import VueI18n from "../../i18n.js";
import { keys } from "lodash";

export default {
  components: {
    autotable: Autotable
  },
  data() {
    return {
      filterDevice: null,
      filterName: null,
      filterEmail: null,
      filterPhoneNumber: null,
      contactdelete: {
        title: "admin.contact.deleteTitle",
        text: "admin.contact.deleteText",
        fun(contact) {
          let name = `<b>${contact.name} [${contact.device}]</b>`;
          return { name };
        }
      }
    };
  },
  computed: {
    ...mapGetters(["getAdminContacts", "getDevices"]),
    columns() {
      return [
        {
          text: this.$t("admin.contact.device"),
          value: "device",
          inputtype: "LOOKUP",
          values: this.devices,
          required: true
        },
        {
          text: this.$t("admin.contact.name"),
          value: "name",
          inputtype: "TEXT",
          maxlength: 100,
          required: true
        },
        {
          text: this.$t("admin.contact.email"),
          value: "email",
          inputtype: "TEXT",
          maxlength: 50
        },
        {
          text: this.$t("admin.contact.phonenumber"),
          value: "phonenumber",
          inputtype: "TEXT",
          maxlength: 25
        },
      ];
    },
    devices() {
      return keys(this.getDevices).map(dev => {
        let l = {"value": dev, "text": dev}
        return l
      })
    },
    getFilteredContacts() {
      let values = this.getAdminContacts
      if (this.filterDevice) {
        values = values.filter(v => v.device == this.filterDevice)
      }
      if (this.filterName) {
        values = values.filter(v => v.name.toLowerCase().indexOf(this.filterName.toLowerCase()) >= 0)
      }
      if (this.filterEmail) {
        values = values.filter(v => v.email.toLowerCase().indexOf(this.filterEmail.toLowerCase()) >= 0)
      }
      if (this.filterPhoneNumber) {
        values = values.filter(v => v.phonenumber.indexOf(this.filterPhoneNumber) >= 0)
      }
      return values
    }
  },
  methods: {
    ...mapActions([
      "doAdminLoadContacts",
      "doAdminCreateContact",
      "doAdminUpdateContact",
      "doAdminDeleteContact",
    ]),
    ...mapMutations(["mShowLongLoader", "mHideLongLoader", "mShowInfoMessage"]),
    async createContact(contact) {
      this.$log.debug("doAdminCreateUser", contact);
      this.doAdminCreateContact(contact);
    },
    async updateContact(contact) {
      this.mShowLongLoader(this.$i18n.t("common.deleting"));
      this.$log.debug("doAdminUpdateContact", contact);
      this.doAdminUpdateContact(contact);
      this.mHideLongLoader();
    },
    async deleteContact(contact) {
      this.mShowLongLoader(this.$i18n.t("common.deleting"));
      this.$log.debug("doAdminDeleteContact", contact);
      await this.doAdminDeleteContact(contact);
      this.mHideLongLoader();
    }
  },
  async beforeRouteEnter(to, from, next) {
    Vue.$log.info("AdminContacts: BEFORE ROUTE ENTER");
    store.commit("mShowLongLoader", VueI18n.t("common.pleasewait"));
    await store.dispatch("doAdminLoadContacts")
    next();
  }
}
</script>
